/* Top explore-nav behavior (sticky-header workaround, SHOP hamburger relocation, VIBES/CUTS toggle).
   Externalized from tp-explore-nav.liquid so the menu logic can be re-published
   without a theme paste. Loaded via <script src="{{ 'swish-explore-nav.js' | file_url }}" defer>.
   Re-publish through the staged-upload + fileUpdate path. */

(function() {
  'use strict';
  /* CUSTOMIZE: Point to your menu config JSON */
  var CONFIG_URL = window.menuConfigUrl || 'https://cdn.shopify.com/s/files/1/0028/1852/files/product-menu-config.json';
  var CLICK_KEY = 'swish_menu_clicks_v16';
  var DEFAULT_ICON = 'star.svg';
  /* Daily Dozen pinned pill — shows in both toggle modes, just before FOR HER. */
  var DD_HREF = '/collections/daily-dozen';
  var DD_ICON = 'https://cdn.shopify.com/s/files/1/0028/1852/files/dd-sale-tag.svg';
  /* Pride pinned pill — SEASONAL. Shows through the end of June, sits just before Daily Dozen,
     skinned with an animated rainbow ring + rainbow label. Auto-disappears on July 1. */
  var PRIDE_HREF = '/pages/shop-for-pride';
  function isPrideActive() { return new Date() < new Date(2026, 6, 1); } /* before Jul 1, 2026 */
  function injectPrideStyle() {
    if (document.getElementById('tp-pride-style')) return;
    var st = document.createElement('style');
    st.id = 'tp-pride-style';
    st.textContent =
      '@keyframes tpPrideFlow{to{background-position:200% 0;}}' +
      '.tp-explore__item--pride .tp-explore__pride-flag{font-size:16px;line-height:1;display:inline-block;}' +
      '.tp-explore__item--pride .tp-explore__label{background:linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#004DFF,#750787);background-size:200% 100%;-webkit-background-clip:text;background-clip:text;color:transparent !important;animation:tpPrideFlow 6s linear infinite;font-weight:800 !important;}' +
      /* animated rainbow ring (desktop pills only — mobile items are icon-over-label, no pill) */
      '@media(min-width:768px){' +
      '.tp-explore__item--pride{border-color:transparent !important;background:rgba(255,255,255,0.04) !important;position:relative;}' +
      '.tp-explore__item--pride::before{content:"";position:absolute;inset:0;border-radius:inherit;padding:1.6px;background:linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#004DFF,#750787,#E40303);background-size:200% 100%;-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;animation:tpPrideFlow 4s linear infinite;pointer-events:none;}' +
      '}' +
      '@media(prefers-reduced-motion:reduce){.tp-explore__item--pride .tp-explore__label,.tp-explore__item--pride::before{animation:none !important;}}';
    document.head.appendChild(st);
  }
  var STATE = { data: null, mode: 'themes', expanded: false };
  var INITIAL_LIMIT = getResponsiveLimit();
  function el(sel) { return document.querySelector(sel); }
  function lsGet(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch(e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch(e) {} }
  /* --- RESPONSIVE LIMIT --- */
  function getResponsiveLimit() {
    var w = window.innerWidth;
    if (w >= 768) return 7;
    if (w >= 400) return 4;
    return 3;
  }
  window.addEventListener('resize', function() {
    var newLimit = getResponsiveLimit();
    if (newLimit !== INITIAL_LIMIT) {
      INITIAL_LIMIT = newLimit;
      if (!STATE.expanded && STATE.data) render();
    }
  });
  /* --- DATE & SEASON HELPERS --- */
  function getSeasonStatus() {
    var now = new Date();
    return { m: now.getMonth() + 1, d: now.getDate() };
  }
  function parseDateStr(str) {
    var map = {Jan:1,Feb:2,Mar:3,Apr:4,May:5,Jun:6,Jul:7,Aug:8,Sep:9,Oct:10,Nov:11,Dec:12};
    var p = str.split(' ');
    if (p.length < 2) return {m:1,d:1};
    return { m: map[p[0]] || 1, d: parseInt(p[1]) || 1 };
  }
  function isSeasonActive(rangeStr) {
    if (!rangeStr) return true;
    var parts = rangeStr.split('-');
    if (parts.length !== 2) return true;
    var now = getSeasonStatus();
    var start = parseDateStr(parts[0].trim());
    var end = parseDateStr(parts[1].trim());
    if (start.m > end.m) {
      return (now.m > start.m || (now.m === start.m && now.d >= start.d)) ||
             (now.m < end.m || (now.m === end.m && now.d <= end.d));
    } else {
      var afterStart = (now.m > start.m || (now.m === start.m && now.d >= start.d));
      var beforeEnd = (now.m < end.m || (now.m === end.m && now.d <= end.d));
      return afterStart && beforeEnd;
    }
  }
  /* --- DATA PROCESSING --- */
  function processData(raw) {
    if (!raw || !raw.variants) return null;
    var margins = (raw.profitability && raw.profitability.margins) || {};
    var volumes = (raw.profitability && raw.profitability.volumeMultipliers) || {};
    var clicks = lsGet(CLICK_KEY, {});
    var currentPath = window.location.pathname;
    if (currentPath.length > 1 && currentPath.endsWith('/')) {
      currentPath = currentPath.slice(0, -1);
    }
    var consolidationMap = {
      't-shirt': 'tshirt', 'womens-t-shirt': 'womens', 'allover-t-shirt': 'tshirt',
      'tank-top': 'tanktop', 'allover-tank-top': 'tanktop', 'long-sleeve': 'tshirt',
      'hoodie': 'hoodie', 'fleece-hoodie': 'hoodie', 'aop-hoodie': 'hoodie',
      'fleece-jacket': 'fleece', 'aop-sweatpants': 'sweats', 'aop-union-suit': 'onesie',
      'triblend-t-shirt': 'triblend', 'crop-top': 'croptop', 'boxy-t-shirt': 'boxytee',
      'swim-briefs': 'swimsuit', 'square-cut-trunks': 'swimsuit', 'swim-trunks': 'swimsuit',
      'button-shirt': 'buttonshirt', 'cotton-button-shirt': 'buttonshirt',
      'long-sleeve-button-shirt': 'buttonshirt', 'pet-shirt': 'pets', 'pet-hoodie': 'pets',
      'headwear': 'headwear', 'sweatshirt': 'sweatshirt', 'kaftan': 'kaftan'
    };
    var iconLookup = {
      'tshirt': 'tshirt', 'womens': 'womens_tshirt', 'tanktop': 'tank_top',
      'hoodie': 'hoodie', 'fleece': 'fleece_jacket', 'sweats': 'aop_sweatpants',
      'onesie': 'aop_union_suit', 'triblend': 'triblend', 'croptop': 'crop_top',
      'boxytee': 'boxy_tee', 'swimsuit': 'swim', 'mug': 'mug',
      'buttonshirt': 'button_shirt', 'kaftan': 'kaftan', 'jersey': 'jersey',
      'shorts': 'shorts', 'tote': 'tote', 'pets': 'pet_shirt',
      'leather': 'leather', 'handfan': 'hand_fan', 'sweatshirt': 'sweatshirt', 'headwear': 'headwear'
    };
    /* CUTS ordering is data-driven, matching the shelf's model: rank product types by
       trailing-365d volume, nudged by margin, lifted by the active season's boosts and any
       new-type boost. Reads cfg.shelfRanking + cfg.profitability so it self-adjusts each
       season (e.g. hoodies/fleece rise in winter) with no manual re-ordering. */
    var RANK = raw.shelfRanking || {};
    var MARGINS = (raw.profitability && raw.profitability.margins) || {};
    var nowMonth = (new Date()).getMonth() + 1;
    function typeScore(key) {
      var s = (RANK.volume && RANK.volume[key]) || 1;
      s *= 1 + (RANK.marginWeight || 0) * (MARGINS[key] || 0);
      if (RANK.newTypeBoost && RANK.newTypeBoost[key]) s *= RANK.newTypeBoost[key];
      var seasonal = RANK.seasonal || {};
      for (var sk in seasonal) {
        var blk = seasonal[sk];
        if (blk && blk.months && blk.months.indexOf(nowMonth) !== -1 && blk.boost && blk.boost[key]) s *= blk.boost[key];
      }
      return s;
    }
    var products = [];
    var seen = new Set();
    raw.variants.forEach(function(v) {
      if (v.hidden_on_menu) return;
      var menuId = consolidationMap[v.key] || v.key.replace(/-/g, '');
      if (seen.has(menuId)) return;
      var vHref = v.href || '/collections/all';
      if (vHref === currentPath) return;
      seen.add(menuId);
      var iconKey = iconLookup[menuId] || v.icon;
      var iconFile = raw.icons[iconKey] || raw.icons['tshirt'] || DEFAULT_ICON;
      var finalPriority = v.priority || 99;
      if (menuId === 'headwear') finalPriority = 8.5;
      products.push({
        id: menuId, label: v.label, href: vHref, icon: iconFile, priority: finalPriority, score: typeScore(v.key)
      });
    });
    /* Highest score first; fall back to the legacy priority for ties (mostly zero-volume tail). */
    products.sort(function(a, b) { return (b.score - a.score) || (a.priority - b.priority); });
    var themes = (raw.collections || []).filter(function(col) {
      if (col.seasonal && col.seasonal.active) {
        if (!isSeasonActive(col.seasonal.active)) return false;
      }
      if (col.href === currentPath) return false;
      return true;
    }).map(function(c) {
      var score = c.baseScore || 0.5;
      if (c.seasonal && c.seasonal.scoreBoost) score += c.seasonal.scoreBoost;
      score += Math.min(3, (clicks[c.key] || 0)) * 0.05;
      var iconFile = DEFAULT_ICON;
      if (c.icon) {
        if (raw.icons && raw.icons[c.icon]) iconFile = raw.icons[c.icon];
        else iconFile = c.icon;
      } else if (raw.icons && raw.icons[c.key]) {
        iconFile = raw.icons[c.key];
      }
      return {
        id: c.key, label: c.text || c.label || c.key, href: c.href, icon: iconFile, score: score, pinned: c.pinned
      };
    });
    themes.sort(function(a, b) {
      if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
      return b.score - a.score;
    });
    return { products: products, themes: themes };
  }
  /* --- RENDER --- */
  function render() {
    var root = el('#tp-explore-root');
    var track = el('#tp-explore-track');
    if (!STATE.data) return;
    var allItems = STATE.data[STATE.mode].slice();
    /* "FOR HER" label normalization only. The old placement override force-promoted
       this item into slots 2-4 regardless of sales; removed 2026-07-21 per Dean —
       womens-t-shirt ranks ~20th of 46 by trailing-365d volume (39 units), so it now
       sits wherever the data-driven typeScore sort places it, like every other cut. */
    var targetIds = ['womens', 'forher', 'for-her', 'womens-t-shirt'];
    var wIdx = allItems.findIndex(function(p) { return targetIds.indexOf(p.id) !== -1; });
    if (wIdx > -1) allItems[wIdx].label = 'FOR&nbsp;HER';
    /* Pinned pills (seasonal Pride + Daily Dozen) live in VIBES ONLY. CUTS (product
       types) keeps every slot for garments — no pinned pills there, per Dean. */
    var ddPath = window.location.pathname.replace(/\/$/, '');
    var prideActive = isPrideActive() && ddPath !== PRIDE_HREF.replace(/\/$/, '');
    /* Seasonal Pride pin. Uses the catalog "Pride" progress-flag icon (flag.svg) — the
       larger tile icon — and keeps the animated --pride skin (rainbow ring + label). The
       duplicate collection tile is removed below while prideActive, so this is the only Pride. */
    var prideItem = { id: 'pride', label: 'Pride', href: PRIDE_HREF, pride: true, icon: 'flag.svg' };
    if (STATE.mode !== 'products') {
      if (prideActive) injectPrideStyle();
      if (prideActive) {
        for (var pdi = allItems.length - 1; pdi >= 0; pdi--) {
          if (allItems[pdi].id === 'pride' || allItems[pdi].href === PRIDE_HREF) allItems.splice(pdi, 1);
        }
      }
      if (ddPath !== DD_HREF) {
        var ddItem = { id: 'daily-dozen', label: 'Daily&nbsp;Dozen', href: DD_HREF, icon: DD_ICON, dd: true };
        /* Pins, in display order: Pride (seasonal) then Daily Dozen. */
        var pins = prideActive ? [prideItem, ddItem] : [ddItem];
        var fhIdx = allItems.findIndex(function(p) { return ['womens','forher','for-her','womens-t-shirt'].indexOf(p.id) !== -1; });
        if (fhIdx > -1) Array.prototype.splice.apply(allItems, [fhIdx, 0].concat(pins));
        else Array.prototype.unshift.apply(allItems, pins);
      } else if (prideActive) {
        /* On the Daily Dozen page itself, DD pill is hidden — still surface Pride near the front. */
        allItems.unshift(prideItem);
      }
    }
    /* TV sits immediately after the Daily Dozen pill (VIBES only). Runs after all pin
       insertion so it lands relative to the final order; no-op if DD pill isn't present. */
    if (STATE.mode !== 'products') {
      var ddIdxForTv = allItems.findIndex(function(p) { return p.id === 'daily-dozen'; });
      var tvIdx = allItems.findIndex(function(p) { return p.id === 'tv'; });
      if (ddIdxForTv > -1 && tvIdx > -1) {
        var tvItem = allItems.splice(tvIdx, 1)[0];
        ddIdxForTv = allItems.findIndex(function(p) { return p.id === 'daily-dozen'; });
        allItems.splice(ddIdxForTv + 1, 0, tvItem);
      }
    }
    var displayItems = STATE.expanded ? allItems : allItems.slice(0, INITIAL_LIMIT);
    var hasMore = allItems.length > INITIAL_LIMIT;
    if (STATE.expanded) root.classList.add('is-expanded');
    else root.classList.remove('is-expanded');
    track.style.opacity = '0.5';
    setTimeout(function() {
      if (allItems.length === 0) {
        track.innerHTML = '<div style="padding:20px; color:#fff;">Loading...</div>';
      } else {
        var html = displayItems.map(function(item, index) {
          var isTop = index < 2;
          var iconUrl = item.icon || '';
          if (iconUrl && iconUrl.indexOf('http') !== 0) iconUrl = 'https://cdn.shopify.com/s/files/1/0028/1852/files/' + iconUrl;
          var ddCls = item.dd ? ' tp-explore__item--dd' : '';
          var prideCls = item.pride ? ' tp-explore__item--pride' : '';
          var ddStyle = '';
          /* Pride with an icon (flag.svg) renders the larger progress-flag image; the
             emoji span is only a fallback if no icon is set. --pride class still animates. */
          var iconInner = (item.pride && !iconUrl)
            ? '<span class="tp-explore__pride-flag">🏳️‍🌈</span>'
            : '<img src="' + iconUrl + '" loading="lazy" alt="' + item.label + '" onerror="this.style.display=\'none\'">';
          return '<a href="' + item.href + '" class="tp-explore__item ' + (isTop ? 'top-pick' : '') + ddCls + prideCls + '" data-swish-id="' + item.id + '"' + ddStyle + '>' +
            '<div class="tp-explore__icon">' +
              iconInner +
            '</div>' +
            '<span class="tp-explore__label">' + item.label + '</span>' +
          '</a>';
        }).join('');
        if (hasMore || STATE.expanded) {
          var btnLabel = STATE.expanded ? 'LESS' : 'MORE';
          html += '<div class="tp-explore__item more-btn" data-swish-more>' +
            '<div class="tp-explore__icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
            '</div>' +
            '<span class="tp-explore__label">' + btnLabel + '</span>' +
          '</div>';
        }
        track.innerHTML = html;
        /* Bind click tracking on items */
        track.querySelectorAll('[data-swish-id]').forEach(function(a) {
          a.addEventListener('click', function() {
            var clicks = lsGet(CLICK_KEY, {});
            var id = a.getAttribute('data-swish-id');
            clicks[id] = (clicks[id] || 0) + 1;
            lsSet(CLICK_KEY, clicks);
          });
        });
        /* Bind more/less button */
        var moreBtn = track.querySelector('[data-swish-more]');
        if (moreBtn) {
          moreBtn.addEventListener('click', function() {
            STATE.expanded = !STATE.expanded;
            render();
          });
        }
      }
      track.style.opacity = '1';
      el('.tp-explore__toggle').setAttribute('data-active', STATE.mode);
      var btns = document.querySelectorAll('.tp-explore__toggle-btn');
      for (var i = 0; i < btns.length; i++) {
        btns[i].classList.toggle('active', btns[i].dataset.mode === STATE.mode);
      }
    }, 50);
  }
  /* --- INIT --- */
  /* SHOP button uses data-tp-drawer-trigger attribute &mdash; the drawer
     script handles it via a delegated listener on document, so it
     survives AJAX page transitions. No JS binding needed here. */
  /* Bind toggle buttons via addEventListener (CSP-safe) */
  document.querySelectorAll('.tp-explore__toggle-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var mode = btn.dataset.mode;
      if (STATE.mode === mode) return;
      STATE.mode = mode;
      STATE.expanded = false;
      render();
      if (navigator.vibrate) navigator.vibrate(5);
    });
  });
  /* Expose for external use if needed */
  window.swishMenu = {
    setMode: function(mode) {
      if (STATE.mode === mode) return;
      STATE.mode = mode;
      STATE.expanded = false;
      render();
    }
  };
  fetch(CONFIG_URL + '?v=' + Date.now())
    .then(function(r) { return r.json(); })
    .then(function(cfg) {
      STATE.data = processData(cfg);
      render();
    })
    .catch(function(e) { console.error('Menu Error:', e); });
})();

/* --- STORE-HEADER INIT REPAIR -------------------------------------------
   Sometime recently the .main-menu__toggle element was removed from
   sections/header.liquid. The Cascade store-header custom element's
   constructor crashes at `this.mobNavToggle.addEventListener(...)` because
   mobNavToggle ends up null. The crash means init() never runs, so the
   setTimeout that adds `cc-header--sticky` to the section never queues —
   which is why the header stopped sticking on scroll.

   The CSS rule .cc-header { position: sticky; ... } above already handles
   the visible regression. This block additionally retries init() after
   DOMContentLoaded so any other init-dependent side-effects can still set
   themselves up. Both are idempotent and become no-ops once the missing
   .main-menu__toggle markup is restored upstream.
-------------------------------------------------------------------------- */
(function() {
  if (window.__swishHeaderRepaired) return;
  window.__swishHeaderRepaired = true;
  function repairStoreHeader() {
    var sh = document.querySelector('store-header');
    if (!sh || typeof sh.init !== 'function') return;
    try {
      sh.stickyInitialised = false;
      sh.init();
    } catch (e) {
      console.warn('[swish] store-header init retry failed:', e && e.message);
    }
  }
  /* Reparent the SHOP hamburger into the main header (to the left of the
     logo). Replaces the missing .main-menu__toggle so the hamburger lives
     in the actual header instead of being buried in the secondary nav.
     Idempotent — guarded by .parentElement check + a window flag elsewhere. */
  function relocateShopButton() {
    var shopBtn = document.querySelector('.tp-explore__shop-btn');
    var header = document.querySelector('header.header__grid');
    if (!shopBtn || !header) return;
    if (shopBtn.parentElement === header) return; // already moved
    shopBtn.classList.add('tp-explore__shop-btn--in-header');
    header.insertBefore(shopBtn, header.firstChild);
  }
  function runAll() {
    repairStoreHeader();
    relocateShopButton();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll, { once: true });
  } else {
    runAll();
  }
})();
